var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOutside(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_547_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8547 24.3418C43.24 23.9908 42.4857 23.9908 41.8711 24.3418L17.7871 38.0954C16.036 39.0954 16.7456 41.769 18.7621 41.769C19.848 41.769 20.7283 42.6493 20.7283 43.7351V62.865C20.7283 63.9696 21.6237 64.865 22.7283 64.865H23.8782C24.9828 64.865 25.8782 63.9696 25.8782 62.865V48.3427C25.8782 47.2381 26.7737 46.3427 27.8782 46.3427H37.2395C38.344 46.3427 39.2395 47.2381 39.2395 48.3427V62.865C39.2395 63.9696 40.1349 64.865 41.2395 64.865H62.9975C64.102 64.865 64.9974 63.9696 64.9974 62.865V43.7353C64.9974 42.6493 65.8778 41.769 66.9638 41.769C68.9805 41.769 69.6901 39.0952 67.9389 38.0951L43.8547 24.3418ZM51.7515 53.7095C51.7515 54.8141 50.856 55.7095 49.7515 55.7095H45.0014C43.8968 55.7095 43.0014 54.8141 43.0014 53.7095V48.552C43.0014 47.4474 43.8968 46.552 45.0014 46.552H49.7515C50.856 46.552 51.7515 47.4474 51.7515 48.552V53.7095ZM61.4903 53.7095C61.4903 54.8141 60.5949 55.7095 59.4903 55.7095H54.7392C53.6346 55.7095 52.7392 54.8141 52.7392 53.7095V48.552C52.7392 47.4474 53.6346 46.552 54.7392 46.552H59.4903C60.5949 46.552 61.4903 47.4474 61.4903 48.552V53.7095Z",
    fill: "#3A98FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8009 67.5027H16.9281V70.1141H13.5918V71.0856H16.9897V70.5993H19.0521V71.0856H22.4491V70.5993H24.5115V71.0856H27.9074V70.5993H29.9708V71.0856H33.3667V70.5993H35.4292V71.0856H38.8261V70.5993H40.8885V71.0856H44.2864V70.5993H46.3478V71.0856H49.7458V70.5993H51.8072V71.0856H55.2041V70.5993H57.2675V71.0856H60.6634V70.5993H62.7269V71.0856H66.1228V70.5993H68.1842V71.0856H71.5831V70.1141H68.8009V67.5027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.826 18.2979H35.4291V19.2694H38.826V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9084 18.2979H24.5115V19.2694H27.9084V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2864 18.2979H40.8884V19.2694H44.2864V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.071 18.2979H2.67407V19.2694H6.071V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3677 18.2979H29.9708V19.2694H33.3677V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.582 18.2979H68.1841V19.2694H71.582V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9601 18.2979H84.5642V19.2694H87.9601V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7457 18.2979H46.3478V19.2694H49.7457V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1227 18.2979H62.7268V19.2694H66.1227V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6634 18.2979H57.2675V19.2694H60.6634V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.203 18.2979H51.8071V19.2694H55.203V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9887 18.2979H13.5918V19.2694H16.9887V18.2979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.071 70.1141H2.67407V71.0856H6.071V70.1141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9601 70.1141H84.5642V71.0856H87.9601V70.1141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5294 70.1141H8.13245V71.0856H10.8692V74.2025H11.8397V70.8056H11.5294V70.1141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6898 61.9726H81.7202V65.3695H82.6898V61.9726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6898 56.5123H81.7202V59.9102H82.6898V56.5123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7203 70.1141H79.1039V71.0856H82.5008V70.5306H82.6899V67.4309H81.7203V70.1141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6898 45.5946H81.7202V48.9925H82.6898V45.5946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6898 51.054H81.7202V54.4509H82.6898V51.054Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6898 29.2156H81.7202V32.6135H82.6898V29.2156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6898 23.7572H81.7202V27.1541H82.6898V23.7572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7203 21.6958H82.6899V18.2979H82.5008H81.7203H79.1039V19.2694H81.7203V21.6958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6898 34.6759H81.7202V38.0728H82.6898V34.6759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0832 23.0485H22.0527V19.2694H22.449V18.2979H22.0527V11.1299H21.0832V18.2979H19.0521V19.2694H21.0832V23.0485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6898 41.493V40.1342H81.7202V41.493H77.9412V42.4645H81.7202V43.5332H82.6898V42.4645H90.989V41.493H82.6898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 26.0016H73.2321V29.3985H74.2016V26.0016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 64.217H73.2321V67.6149H74.2016V64.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 53.2983H73.2321V56.6953H74.2016V53.2983Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 42.3796H73.2321V45.7766H74.2016V42.3796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 47.838H73.2321V51.2359H74.2016V47.838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 15.0829H73.2321V18.4799H73.6445V19.2695H77.0425V18.2979H74.2016V15.0829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 58.7567H73.2321V62.1546H74.2016V58.7567Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 75.1346H73.2321V77.8097H74.2016V75.1346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 20.5413H73.2321V23.9392H74.2016V20.5413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 36.9203H73.2321V40.3182H74.2016V36.9203Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 69.6763H73.2321V73.0733H74.2016V71.0857H77.0425V70.1141H74.2016V69.6763Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 31.46H73.2321V34.8579H74.2016V31.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2016 9.6236H73.2321V13.0215H74.2016V9.6236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 32.5892H10.8691V35.9872H11.8397V32.5892Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 10.7529H10.8691V14.1508H11.8397V10.7529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 48.9683H10.8691V52.3662H11.8397V48.9683Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 27.1309H10.8691V30.5278H11.8397V27.1309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 54.4276H10.8691V57.8245H11.8397V54.4276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 59.8859H10.8691V63.2839H11.8397V59.8859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 76.265H10.8691V78.94H11.8397V76.265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8692 19.6091H11.8397V16.2122H10.8692V18.2979H8.13245V19.2695H10.8692V19.6091Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 65.3463H10.8691V68.7442H11.8397V65.3463Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 21.6716H10.8691V25.0695H11.8397V21.6716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 43.5089H10.8691V46.9058H11.8397V43.5089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8397 38.0496H10.8691V41.4475H11.8397V38.0496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1607 78.8389H25.4436V76.274H24.473V78.8389V79.8105V82.3764H25.4436V79.8105H39.1607V82.3764H40.1312V76.274H39.1607V78.8389Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOutside);
export default __webpack_public_path__ + "static/media/homeOutside.d553f71bbf3ecf7d57f691699082599e.svg";
export { ForwardRef as ReactComponent };